import React from 'react';

import { GlobalStyle } from './GlobalStyle';

export const BaseLayout: React.FC = ({ children }) => (
  <>
    <GlobalStyle />
    {children}
  </>
);
